import OtaManageVersionsContainer from './OtaManageVersionsContainer';

export default OtaManageVersionsContainer;
